import { TagMap } from "../types";

export const getSpaceTags = (names: string[], tags: TagMap): TagMap => {
  let spaceTags: TagMap = {};
  names.map((item: string) => {
    if (item in tags) {
      spaceTags[item] = tags[item];
    }
  });
  return spaceTags;
};
